export enum TeacherFeedBackStatus {
    ACTIVE = 'ACTIVE',
    COMPLETE = "COMPLETE",
    SKIP = "SKIP",
    NOTSTARTED = "NOT_STARTED",
    INACTIVE = "INACTIVE",
    DISABLED = "DISABLED"
  }


// WEBPACK FOOTER //
// ./ts/app/shared/types/teacher-feedback-status-type.ts